import React, { createContext, useContext, useEffect, useState } from "react";
import { adminApi } from "@/admin/api";

const AuthContext = createContext({ user: null, loading: true, login: async () => {}, logout: () => {} });

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("wb_admin_token");
    if (!token) {
      setLoading(false);
      return;
    }
    let active = true;
    adminApi
      .get("/admin/me")
      .then((r) => { if (active) setUser(r.data); })
      .catch(() => {
        localStorage.removeItem("wb_admin_token");
        localStorage.removeItem("wb_admin_user");
      })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/admin/login", { email, password });
    localStorage.setItem("wb_admin_token", data.token);
    localStorage.setItem("wb_admin_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("wb_admin_token");
    localStorage.removeItem("wb_admin_user");
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, loading, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAdminAuth = () => useContext(AuthContext);
